<template>
  <div>
    <section>
      <b-card-code
        no-body
      >
        <b-card>
          <b-row>
            <b-col
              xl="12"
              sm="12"
            >
              <b-card>
                <b-row>
                  <b-col
                    v-for="item in data"
                    :key="item.icon"
                    xl=""
                    sm="6"
                    class="mx-1"
                    :class="['mb-1','rounded' ,'px-1','py-2','text-white', item.customClass, {
                      'card-online': item.color === 'online',
                      'card-error': item.color === 'error',
                      'card-limit': item.color === 'limit',
                      'card-handle': item.color === 'handle',
                      'card-offline': item.color === 'offline',
                      'card-total': item.color === 'total',
                    }]"
                  >
                    <b-media no-body>
                      <b-media-body
                        class="my-auto"
                        style="text-align: center;"
                      >
                        <h4 class="font-weight-bolder text-white mb-0">
                          {{ item.title }}
                        </h4>
                        <b-card-text class="xmb-0">
                          {{ item.subtitle }}
                        </b-card-text>
                      </b-media-body>
                      <b-media-aside>
                        <b-avatar
                          size="66"
                          :variant="item.color"
                          class="bg-white"
                        >
                          <b-img
                            width="45"
                            height="45"
                            :src="item.icons"
                          />
                        </b-avatar>
                      </b-media-aside>
                    </b-media>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-card-code>
      <b-card-code>
        <b-card>
          <div class="d-flex justify-content-between flex-wrap">
            <!-- sorting  -->
            <b-form-group
              label="Sort"
              label-size="sm"
              label-align-sm="left"
              label-cols-sm="3"
              label-for="sortBySelect"
              class="ml-1"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sortBySelect"
                  v-model="sortBy"
                  :options="sortOptions"
                >
                  <template #first>
                    <option value="">
                      none
                    </option>
                  </template>
                </b-form-select>
                <b-form-select
                  v-model="sortDesc"
                  size="sm"
                  :disabled="!sortBy"
                >
                  <option :value="false">
                    Asc
                  </option>
                  <option :value="true">
                    Desc
                  </option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>
            <!-- filter -->
            <b-form-group
              label="Filter"
              label-cols-sm="2"
              label-align-sm="left"
              label-size="sm"
              label-for="filterInput"
              class="mr-1"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <!-- Table -->
          <b-table
            striped
            hover
            responsive
            sticky-header
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            class="position-relative"
            @filtered="onFiltered"
          >
            <template #cell(status)="data">
              <b-badge :variant="status[0][data.value]">
                <!-- {{ status[0][data.value] }} -->
                Offline
              </b-badge>
            </template>
            <template #cell(action)="row">
              <span>
                <template slot:button-content>
                  <b-button-group>
                    <b-button
                      v-b-modal.modal-detail
                      variant="purple"
                      class="mx-1"
                      size="sm"
                    >See Details</b-button>
                    <b-button
                      v-b-modal.modal-update
                      variant="warning"
                      size="sm"
                    >Update</b-button>
                  </b-button-group>
                </template>
              </span>
            </template>

          </b-table>
          <template>
            <b-modal id="modal-update">
              <form
                ref="form"
                @submit.stop.prevent="handleSubmit"
              >
                <b-form-group
                  label="Status"
                >
                  <v-select
                    v-model="selected"
                    :options="options"
                    value-field="item"
                    text-field="name"
                    :selected-size="2"
                      placeholder="--Select Status --"
                        class="w-100"
                    disabled-field="notEnabled"
                  />
                </b-form-group>
                <b-form-group
                  label="Information"
                  label-for="name-input"
                  invalid-feedback="Name is required"
                  :state="nameState"
                >
                  <b-form-textarea
                    id="name-input"
                    v-model="name"
                    :state="nameState"
                    required
                  />
                </b-form-group>
              </form>
            </b-modal>
          </template>
          <template>
            <b-modal
              id="modal-detail"
              title="Detail Information"
              hide-footer
               size="sm"
            >
              <b-container class="d-flex mx-3 ">
                <b-row class="d-flex flex-column">
                  <div class="d-flex my-1">
                    <b-col lg="5" class="font-judul">
                        Area
                    </b-col>
                    <b-col lg="2" class="font-judul">
                        :
                    </b-col>
                    <b-col lg="5">
                        Sparing
                    </b-col>
                  </div>
                  <div class="d-flex">
                    <b-col lg="5" class="font-judul">
                       Location
                    </b-col>
                    <b-col lg="2" class="font-judul">
                        :
                    </b-col>
                    <b-col lg="5">
                        PAC AB
                    </b-col>
                  </div>
                  <div class="d-flex mt-1">
                    <b-col lg="5" class="font-judul">
                       Site
                    </b-col>
                    <b-col lg="2" class="font-judul">
                        :
                    </b-col>
                    <b-col lg="5">
                        WTB 1
                    </b-col>
                  </div>
                  <div class="d-flex">
                    <b-col lg="5" class="font-judul">
                       Value /
                       Parameter
                    </b-col>
                    <b-col lg="2" class="font-judul">
                        :
                    </b-col>
                    <b-col lg="5">
                        PAC AB
                    </b-col>
                  </div>
                  <div class="d-flex my-1">
                    <b-col lg="5" class="font-judul">
                       Date Repair
                    </b-col>
                    <b-col lg="2" class="font-judul">
                        :
                    </b-col>
                    <b-col lg="5">
                        12.00 12-02-2023
                    </b-col>
                  </div>
                </b-row>
                <!-- <b-row
                  class="d-flex flex-column ml-1 mr-4"
                >
                  <b-col>Area <span> : </span> </b-col>
                  <b-col>Location <span> : </span></b-col>
                  <b-col>Site <span> : </span></b-col>
                  <b-col>Value/Parameter <span>:</span></b-col>
                  <b-col>Date Repair <span> : </span></b-col>
                </b-row>
                <b-row
                  class="d-flex flex-column"
                >
                  <b-col>Sparing</b-col>
                  <b-col>Pac Ab</b-col>
                  <b-col>Wtp 1</b-col>
                  <b-col>3 Kwh</b-col>
                  <b-col>12.00 12-02-2023</b-col>
                </b-row> -->
              </b-container>
            </b-modal>
          </template>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <p class="text-nowrap mb-md-0 mr-1 align-left" />
            <!-- page length -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                style="align-content: right"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-card-code>
    </section>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCol,
  //   BOverlay,
  BCard,
  BRow,
  BTable,
  BImg,
  BBadge,
  BMediaBody,
  BAvatar,
  BCardText,
  BMediaAside,
  BMedia,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BModal,
  BFormTextarea,
  BCardBody,
  BButtonGroup,
//   BLink,
//   BDropdown,
//   BDropdownItem,
} from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    BCardCode,
    BCol,
    // BOverlay,
    BCard,
    BFormTextarea,
    BRow,
    BTable,
    BImg,
    BBadge,
    BMediaBody,
    BAvatar,
    BCardText,
    BMediaAside,
    BMedia,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BModal,
    BCardBody,
    BButtonGroup,
    // BLink,
    // BDropdown,
    // BDropdownItem,
  },
  data() {
    return {
      StatusOptions: [
        { title: 'Online', value: 'On' },
        { title: 'Error', value: 'Er' },
        { title: 'Limit', value: 'Li' },
        { title: 'Handle', value: 'Ha' },
        { title: 'Offline', value: 'Of' },
      ],
      status: [{
        On: 'Online', Er: 'Error', Li: 'Limit', Ha: 'Handle', Of: 'Offine',
      },
      {
        On: 'purple', Er: 'light-danger', Li: 'light-danger', Ha: 'light-warning', Of: 'light-info',
      }],
      options: [
        { item: 'A', name: 'Option A' },
        { item: 'B', name: 'Option B' },
        { item: 'D', name: 'Option C', notEnabled: true },
        { item: { d: 1 }, name: 'Option D' },
      ],
      items: [
        {
          id: 1,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          // status: 'On',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 2,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 3,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 4,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 5,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 6,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 7,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 8,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 9,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
        {
          id: 10,
          date: '12.00 12-02-2023',
          device: 'Power Meter 3 Phase',
          inform: 'Kerusakan Berada Di Sensor PH',
          actions: 'actions',
        },
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        { key: 'date' },
        { key: 'device' },
        { key: 'status' },
        { key: 'inform' },
        { key: 'action' },

      ],
      data: [
        {
          icons: require('@/assets/images/icons/check.svg'),
          icon: 'UserIcon',
          color: 'online',
          title: 0,
          subtitle: 'Online',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/emergency-siren.svg'),
          icon: 'UsersIcon',
          color: 'error',
          title: 0,
          subtitle: 'Error',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/limit.svg'),
          icon: 'UsersIcon',
          color: 'limit',
          title: 0,
          subtitle: 'Limit',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/repair-tools.svg'),
          icon: 'UsersIcon',
          color: 'handle',
          title: 0,
          subtitle: 'Handle',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline2.svg'),
          icon: 'DollarSignIcon',
          color: 'offline',
          subtitle: 'Offline',
          title: 0,
          width: 40,
          customClass: 'mb-3 mb-sm-0 w-40',
        },
        {
          icons: require('@/assets/images/icons/devicesku.svg'),
          icon: 'UsersIcon',
          color: 'total',
          title: 0,
          subtitle: 'Total',
          customClass: 'device mb-3 mb-xl-0',
        },
      ],
    }
  },
}
</script>

<style>
.font-judul{
  font-weight: bold;
}
.table-b-table-default{
  text-align: center!important;;
}
.custom-select{
  margin-bottom: 1px!important;
}
.device{
  width: 30px !important;
}
.media-aside{
   margin-right: 0!important;
}
 .btn-purple {
    background-color: #6F55E9;
    color: #ffffff;
  }
.card-body{
    padding-bottom: 0!important;
}
.card-header{
    padding-bottom: 0!important;
    padding-top: 0!important;
}
  .card-online {
    background-color: #28a745; /* Warna hijau (ganti dengan kode warna yang Anda inginkan) */
  }

  .card-error{
    background-color: #dc3545; /* Warna merah (ganti dengan kode warna yang Anda inginkan) */
  }

  .card-limit {
    background-color: #FF9F43; /* Warna biru (ganti dengan kode warna yang Anda inginkan) */
  }
  .card-handle {
    background-color: #80CEE1; /* Warna biru (ganti dengan kode warna yang Anda inginkan) */
  }
  .card-offline{
    background-color: #6C757D;
  }
  .card-total {
    background-color: #007bff; /* Warna biru (ganti dengan kode warna yang Anda inginkan) */
  }

</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
